<template>
	<div class="report-mobile">
		<div class="header">
			<img src="@/assets/images/mobile/white@2x.png" alt="" />
		</div>
		<div class="page-content">
			<!-- 内容顶部阴影 -->
			<img
				class="head-shadown"
				src="@/assets/images/mobile/bg_head.png"
				alt=""
			/>
			<div class="page-infos">
				<div v-if="!props.isDelete" class="pri-title">
					{{ props.shareData.name || "-" }}配储测算报告
				</div>
				<div v-if="!props.isDelete" class="secon-title">
					本报告由 轻舟能科储能精算师 生成于
					{{
						moment(props.shareData.createDate).format(
							"YYYY年MM月DD日"
						)
					}}
				</div>
				<div v-if="!props.isDelete" class="page-infos-box">
					<div class="title-img">
						<img src="@/assets/images/mobile/title_1.png" alt="" />
						<div class="font">负载情况</div>
					</div>
					<div class="info-font">
						{{ props.shareData.name }}项目位于【{{
							props.shareData.province
						}}】{{
							props.shareData.area == "全省"
								? ""
								: `【${props.shareData.area}】`
						}}，在{{
							moment(props.shareData.startDate).format(
								"YYYY年MM月DD日"
							)
						}}～{{
							moment(props.shareData.endDate).format(
								"YYYY年MM月DD日"
							)
						}}之间共{{ props.shareData.loadDays }}天内，总用电量{{
							toFixed(props.shareData.sumElec / 1000, 2) || "-"
						}}
						MWh，日均用电量{{ props.shareData.meanElec || "-" }}
						kWh，详细用电情况如下图：
					</div>
					<div class="echarts m8">
						<div class="echarts-title">电量数据概览</div>
						<div class="word1">
							<div class="font">概览每天用电量变化情况</div>
						</div>
						<!-- 电量数据概览 -->
						<div class="echarts-box">
							<echarts-component
								:options="props.electricityOverviewOptions"
							></echarts-component>
						</div>
					</div>
					<div class="echarts">
						<div class="detail-infos">
							依据“储能精算师"聚类规则，
							<span
								v-for="(item, index) in typicalDates"
								:key="index"
							>
								<span class="special">{{ item }}</span>
								{{
									index == typicalDates.length - 1 ? "" : "、"
								}}
							</span>
							为{{
								typicalDates.length
							}}种典型负荷曲线，可分别代表
							<span
								v-for="(item, index) in typicalDays"
								:key="index"
							>
								<span class="special">{{ item }}天</span>
								{{
									index == typicalDays.length - 1 ? "" : "、"
								}}
							</span>
							的负载数据，其他负荷曲线与这{{
								typicalDays.length || "-"
							}}日的负荷曲线最接近，选取这{{
								typicalDays.length || "-"
							}}日负荷作为典型日负荷。典型日负荷变化曲线如下图:
						</div>
						<div class="echarts-title">典型日负荷</div>
						<div class="word2">
							<div class="font">
								典型日负荷是算法根据负载数据聚合出的特征曲线，代表了负荷在一天内波动的情况
							</div>
						</div>
						<!-- 典型日负荷 -->
						<div class="echarts-box">
							<echarts-component
								:options="props.typicalLoadOptions"
							></echarts-component>
						</div>
					</div>
					<div class="info-tips">
						鉴于以上情况，可以考虑为项目增配储能，以实现削峰填谷、控制需量等效果，为企业降低用电成本，提升环保指数。
					</div>
					<div class="title-img">
						<img src="@/assets/images/mobile/title_2.png" alt="" />
						<div class="font">配储评估</div>
					</div>
					<div class="info-font">分析使用的储能系统参数如下表：</div>
					<!-- 配储评估参数 -->
					<parameter-lists
						:strategyCurveListData="strategyCurveListData"
					></parameter-lists>

					<div
						v-if="jobStepVO"
						class="detail-infos"
						style="margin-top: 24px"
					>
						从
						<span class="special">
							{{ jobStepVO.initPower || "-" }}kW/{{
								jobStepVO.initCapacity || "-"
							}}kWh
						</span>
						开始，以
						<span class="special">
							{{ jobStepVO.periodPower || "-" }}kW/{{
								jobStepVO.periodCapacity || "-"
							}}kWh
						</span>
						的储能规模逐步叠加进行模拟运行，结果如下:
					</div>
					<div class="echarts">
						<div class="echarts-title">日均收益</div>
						<div class="word1">
							<div class="font">
								储能日均收益 = 统计时间内总收益（元） / 天数
							</div>
						</div>
						<!-- 日均收益 -->
						<div class="echarts-box">
							<echarts-component
								:options="props.dailyIncomeOptions"
							></echarts-component>
						</div>
					</div>
					<div class="echarts">
						<div class="echarts-title">单位容量日均收益</div>
						<div class="word2">
							<div class="font">
								单位容量日均收益 = 储能日均收益（元/天） /
								装机容量（kWh）
							</div>
						</div>
						<!-- 单位容量日均收益 -->
						<div class="echarts-box">
							<echarts-component
								:options="props.unitCapacityOptions"
							></echarts-component>
						</div>
					</div>
					<!-- v1新增表格 -->
					<div class="income-table">
						<income-detail-table
							:averageDatas="props.averageDatas"
						></income-detail-table>
					</div>

					<!-- 配储方案 -->
					<div class="title-img">
						<img src="@/assets/images/mobile/title_3.png" alt="" />
						<div class="font">配储方案</div>
					</div>
					<scheme-methods
						:schemeMethodsInfo="props.schemeMethodsInfo"
						:typicalDates="typicalDates"
					></scheme-methods>

					<!-- 经济分析 -->
					<div class="title-img">
						<img src="@/assets/images/mobile/title_4.png" alt="" />
						<div class="font">经济分析</div>
					</div>
					<economic-analysis
						:economicInfo="props.economicInfo"
					></economic-analysis>
				</div>
				<div v-if="props.isDelete" class="empty">
					<img src="@/assets/images/emptyProject.png" alt="" />
					<div class="font">该链接已失效</div>
				</div>
			</div>
		</div>
		<div class="copyright">
			<img src="@/assets/images/mobile/logo-company.png" alt="" />
			<div class="font">Copyright © 2023 杭州轻舟科技有限公司</div>
		</div>
	</div>
</template>

<script setup>
import {defineProps, ref, watch} from "vue";
// 引入echarts
import EchartsComponent from "@/components/EchartsComponent.vue";
// 引入setNotOpt
import {toFixed} from "@/plugins/index.js";
// 引入moment
import moment from "moment";

// 引入策略收益表
import IncomeDetailTable from "./components/H5/IncomeDetailTable.vue";
// 配储方案
import SchemeMethods from "./components/H5/SchemeMethods.vue";
// 经济分析
import EconomicAnalysis from "./components/H5/EconomicAnalysis.vue";
// 配储评估参数
import ParameterLists from "../components/H5/ParameterLists.vue";

let props = defineProps({
	shareData: {
		type: Object,
		default: () => {},
	},
	isDelete: {
		type: Boolean,
		default: false,
	},
	electricityOverviewOptions: {
		type: Object,
		default: () => {},
	},
	typicalLoadOptions: {
		type: Object,
		default: () => {},
	},
	// 配储分析参数
	strategyCurveListData: {
		type: Array,
		default: () => {
			return [];
		},
	},
	dailyIncomeOptions: {
		type: Object,
		default: () => {},
	},
	unitCapacityOptions: {
		type: Object,
		default: () => {},
	},
	v1ReportInfos: {
		type: Object,
		default: () => {
			return null;
		},
	},
	averageDatas: {
		type: Object,
		default: () => {},
	},
	// 配储方案数据
	schemeMethodsInfo: {
		type: Object,
		default: () => {
			return null;
		},
	},
	// 经济分析数据
	economicInfo: {
		type: Object,
		default: () => {
			return null;
		},
	},
});

// 负载典型日日期
const typicalDates = ref([]);
// 负载典型日天数
const typicalDays = ref([]);
// 储能规模
const jobStepVO = ref({
	initPower: undefined,
	initCapacity: undefined,
	periodPower: undefined,
	periodCapacity: undefined,
});

watch(
	() => props.v1ReportInfos,
	newVal => {
		if (newVal) {
			console.log(newVal);
			typicalDates.value = newVal.typicalDates;
			typicalDays.value = newVal.typicalDays || [];
			jobStepVO.value = newVal.jobStepVO;
		}
	},
	{immediate: true, deep: true}
);
</script>

<style lang="less" scoped>
.report-mobile {
	min-height: 100vh;
	overflow-y: auto;
	background-image: url(~@/assets/images/mobile/bg@2x.png);
	background-color: #959fb3;
	background-repeat: no-repeat;
	background-size: 100% auto;
	padding: 8px 10px;
	display: flex;
	flex-direction: column;
	.header {
		img {
			width: 148px;
			height: 40px;
		}
	}
	.page-content {
		margin-top: 8px;
		flex: 1;
		background: #ffffff;
		box-shadow: 0 4px 16px 0 #68768629;
		border-radius: 8px;
		position: relative;
		padding-top: 24px;
		.head-shadown {
			width: 100%;
			height: 240px;
			position: absolute;
			top: 0;
			left: 0;
		}

		.page-infos {
			z-index: 999;
			position: relative;
			width: 100%;
			height: 100%;
			.pri-title {
				width: 100%;
				font-family: PingFangSC-Medium;
				font-weight: 600;
				font-size: 20px;
				color: #000000;
				letter-spacing: 0;
				line-height: 28px;
				text-align: center;
			}
			.secon-title {
				height: 22px;
				opacity: 0.45;
				font-family: PingFangSC-Regular;
				font-weight: 400;
				font-size: 14px;
				color: #000000;
				letter-spacing: 0;
				text-align: center;
				line-height: 22px;
				margin-top: 4px;
			}

			&-box {
				min-height: calc(100% - 20px);
				background: #ffffff;
				box-shadow: 0 4px 16px 0 #68768629;
				border-radius: 8px;
				margin-top: 20px;
				padding: 0px 16px;
				padding-bottom: 16px;
				.title-img {
					width: 100%;
					text-align: center;
					height: 52px;
					position: relative;

					.font {
						position: absolute;
						bottom: 0;
						left: 50%;
						transform: translateX(-50%);
						height: 28px;
						font-family: PingFangSC-SNaNpxibold;
						font-weight: 600;
						font-size: 20px;
						color: #000000;
						letter-spacing: 0;
						text-align: center;
						line-height: 28px;
					}

					img {
						height: 48px;
					}
				}
				.info-font {
					opacity: 0.85;
					font-family: PingFangSC-Regular;
					font-weight: 400;
					font-size: 14px;
					color: #000000;
					letter-spacing: 0;
					text-align: justify;
					line-height: 20px;
					margin-top: 16px;
					margin-bottom: 8px;
				}

				.word1 {
					height: 40px;
					border-radius: 1px 2px 2px 2px 2px;
					background-image: url(~@/assets/images/mobile/word_bg_1.png);
					background-size: 100% 100%;
					margin-top: 4px;
					position: relative;
					.font {
						position: absolute;
						bottom: 5px;
						left: 10px;
						height: 22px;
						opacity: 0.5;
						font-family: PingFangSC-Regular;
						font-weight: 400;
						font-size: 14px;
						color: #000000;
						letter-spacing: 0;
						line-height: 22px;
					}
				}
				.word2 {
					height: 62px;
					border-radius: 1px 2px 2px 2px 2px;
					background-image: url(~@/assets/images/mobile/word_bg_2.png);
					background-size: 100% 100%;
					margin-top: 4px;
					position: relative;
					.font {
						position: absolute;
						top: 14px;
						// bottom: 5px;
						left: 10px;
						height: 22px;
						opacity: 0.5;
						font-family: PingFangSC-Regular;
						font-weight: 400;
						font-size: 14px;
						color: #000000;
						letter-spacing: 0;
						line-height: 22px;
					}
				}
			}

			.empty {
				background-color: #fff;
				margin-top: 100px;
				padding-top: 56px;
				text-align: center;
				.font {
					height: 24px;
					opacity: 0.65;
					font-family: PingFangSC-Regular;
					font-weight: 400;
					font-size: 16px;
					color: #000000;
					letter-spacing: 0;
					text-align: center;
					line-height: 24px;
					margin-top: 12px;
				}
			}
		}

		.echarts {
			margin-top: 8px;
			margin-bottom: 24px;
			&-title {
				border-left: 4px solid #0058fc;
				height: 24px;
				opacity: 0.85;
				font-family: PingFangSC-Medium;
				font-weight: 500;
				font-size: 16px;
				color: #000000;
				letter-spacing: 0;
				line-height: 24px;
				padding-left: 8px;
			}
			&-box {
				height: 251px;
				margin-top: 16px;
			}
		}
		.m8 {
			margin-top: 8px;
		}
	}

	.copyright {
		text-align: center;
		margin: 16px 0px;

		img {
			width: 96px;
			height: 32px;
		}

		.font {
			height: 22px;
			font-family: PingFangSC-Regular;
			font-weight: 400;
			font-size: 14px;
			color: #ffffffd9;
			letter-spacing: 0;
			text-align: center;
			line-height: 22px;
			margin-top: 4px;
		}
	}
}
</style>

<style lang="less">
.tips {
	height: 48px;
	background: #0058fc14;
	border: 1px solid #0058fc3d;
	border-radius: 4px;
	padding: 12px 16px;

	font-family: PingFangSC-Medium;
	font-weight: 600;
	font-size: 16px;
	color: #0058fc;
	letter-spacing: 0;
	line-height: 24px;
}

.detail-infos {
	color: #000000d9;
	font-size: 16px;
	font-family: PingFangSC;
	font-weight: 400;
	line-height: 24px;
	letter-spacing: 0;
	text-align: justify;
	margin-bottom: 12px;
	.special {
		color: #0058fc;
		font-weight: 500;
	}
}

.info-tips {
	background: #0058fc14;
	border: 1px solid #0058fc3d;
	border-radius: 4px;
	padding: 8px 12px;

	font-family: PingFangSC-Medium;
	font-weight: 500;
	font-size: 14px;
	color: #0058fc;
	letter-spacing: 0;
	text-align: justify;
	line-height: 20px;
	margin-top: -8px;
	margin-bottom: 24px;
}
</style>
